export default {
	save: 'Dəyişikliklər uğurla qeyd edildi',
	error: 'Xəta. Dəstəklə əlaqə saxlayın',
	'old password was incorrect': 'Köhnə parol səhv idi',
	templateDuplicated: 'Şablon uğurla çoxaldıldı',

}